import React from "react";
import "./ArticlePreviewPrefaceItem.css";
import ReactHtmlParser from "react-html-parser";
import {
  setPreviewingTextLineIDs,
  setPreviewingItemHidingMode
} from "../../redux/actions/editArticlePanel";
import { connect } from "react-redux";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";

class ArticlePreviewPrefaceItem extends React.Component {
  constructor(props) {
    super(props);
    this.onHover = this.onHover.bind(this);

    this.onInvisibleClicked = this.onInvisibleClicked.bind(this);
    this.onHighlightClicked = this.onHighlightClicked.bind(this);
  }

  onHover(hovering) {
    const { item, setPreviewingTextLineIDs } = this.props;

    if (hovering) {
      setPreviewingTextLineIDs({ textLineIDs: item.textLineIDs });
    } else {
      setPreviewingTextLineIDs({ textLineIDs: null });
    }
  }

  onInvisibleClicked() {
    const { mode, item, setPreviewingItemHidingMode } = this.props;

    if (mode === "invisible") {
      setPreviewingItemHidingMode({ id: item.id, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: item.id, mode: "invisible" });
    }
  }

  onHighlightClicked() {
    const { mode, item, setPreviewingItemHidingMode } = this.props;

    if (mode === "highlight") {
      setPreviewingItemHidingMode({ id: item.id, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: item.id, mode: "highlight" });
    }
  }

  render() {
    const { item, mode } = this.props;

    return (
      <div style={{ position: "relative", paddingBottom: "10pt" }}>
        <div
          className="preview_preface_container"
          onMouseEnter={() => this.onHover(true)}
          onMouseLeave={() => this.onHover(false)}
        >
          {ReactHtmlParser(item.text.replace(/\n/g, "<br>"))}
        </div>
        <ButtonGroup
          style={{ position: "absolute", top: 0, right: "-70px" }}
          size="sm"
        >
          <Button
            variant={mode === "invisible" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onInvisibleClicked}
          >
            <span className="fa fa-eye-slash" />
          </Button>
          <Button
            variant={mode === "highlight" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onHighlightClicked}
          >
            <span className="fa fa-language" />
          </Button>
        </ButtonGroup>
      </div>
    );
  }
}

const mapDispatch = {
  setPreviewingTextLineIDs,
  setPreviewingItemHidingMode
};

const mapState = (state, ownProps) => {
  const { editArticlePanel } = state;
  const { previewHidingItemIDs } = editArticlePanel;

  return {
    mode: previewHidingItemIDs[ownProps.item.id]
  };
};

export default connect(
  mapState,
  mapDispatch
)(ArticlePreviewPrefaceItem);
